<ion-header class="ion-no-border page menu-page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div class="leada-powered">POWERED BY LEADA AG</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="goBack()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-padding page" no-bounce>
  <div #line class="line" [style.top]="lineY"></div>
  <ion-list lines="none" class="menu">
    <ion-item button disabled><div translate>MENU.PROFILE.NAME</div></ion-item>
    <ion-item button (click)="showPositionPage()"><div translate>MENU.PROFILE.MYPROFILE</div></ion-item>
    <ion-item button><div translate>MENU.PROFILE.MYACCOUNT</div></ion-item> 
    <ion-item button class="second-level" (click)="showPasswordSetPage()"><div translate>MENU.PROFILE.CHANGE_PASSWORD</div></ion-item> 
    <ion-item button class="second-level" (click)="logout()"><div translate>MENU.PROFILE.LOGOUT</div></ion-item> 
    <ion-item button class="second-level" (click)="unregister()"><div translate>MENU.PROFILE.UNREGISTER</div></ion-item> 
</ion-list>

</ion-content>

<ion-footer class="page">
  <ion-button fill="clear" shape="round" (click)="showSettings()" class="settings"><ion-icon slot="icon-only"></ion-icon></ion-button>
  <ion-button fill="clear" shape="round" (click)="showSearch()" class="search"><ion-icon slot="icon-only"></ion-icon></ion-button>
</ion-footer>
